import { render, staticRenderFns } from "./CreateSimOrderCard.vue?vue&type=template&id=04ae3762&"
import script from "./CreateSimOrderCard.vue?vue&type=script&lang=js&"
export * from "./CreateSimOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateSimOrderCard.vue?vue&type=style&index=0&id=04ae3762&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports